import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { AutomapperService } from "../../../../../core/automapper/automapper.service";
import { BASE_API_URL } from "../../../../../core/environment.tokens";
import { ParameterService } from "../../../../../core/navigation/parameter.service";
import { EditPendService } from "../../../../../shared/pend/edit-pend.service";
import { IChaseTimelineResponseV1 } from "../../../../../shared/timeline/chase-timeline-item-v1.model";
import { toTimelineItems } from "../../../../../shared/timeline/chase-timeline-v1.mapper";
import { TimelineItem } from "../../../../../shared/timeline/timeline-item.model";

@Injectable({
  providedIn: "root",
})
export class InternalPendDetailTimelineService {

  constructor(
    @Inject(BASE_API_URL) private readonly baseApiUrl: string,
    private http: HttpClient,
    private automapper: AutomapperService,
    private parameterService: ParameterService,
    private editPendService: EditPendService
  ) { }

  getPendGdFromPath(): string {
    return this.parameterService.getNormal("pendGd", "");
  }

  // Switched to the V1 chase timeline endpoint so DynamoDB-stored comments show up alongside
  // SQL Server pend history events (created, status changes, document uploads).
  getPendTimelineActivityItems(): Observable<TimelineItem[]> {
    const pendId = this.getPendGdFromPath();

    return this.editPendService.getChasePendData(+pendId).pipe(
      switchMap(chasePend => {
        // Matches the legacy pendTimelineActivity endpoint's existing default of 5 records.
        const url = `${this.baseApiUrl}v1chases/${chasePend.chaseId}/timeline?resources=pend&resourceIds=${pendId}&pageSize=5`;
        return this.http.get<IChaseTimelineResponseV1>(url);
      }),
      map(response => toTimelineItems(response && response.items))
    );
  }
}
